import { useGeneralStore } from "@/stores/generalStore";
import { useMjmlStore, AuthorizationError } from "@/stores/mjmlStore";
import { useNotificationsStore } from "@/stores/notifications";
import { useI18n } from "vue-i18n";
import { ref } from "vue";

export default () => {
  const generalStore = useGeneralStore();
  const mjmlStore = useMjmlStore();
  const notificationsStore = useNotificationsStore();
  const { t } = useI18n();

  const loaded = ref(false);

  function loadTemplate() {
    generalStore.loadingTemplate = true;
    mjmlStore
      .authorizePromise()
      .then(() => {
        mjmlStore
          .load()
          .then(() => {
            loaded.value = true;
            generalStore.loadingTemplate = false;
          })
          .catch((e) => {
            notificationsStore.createNotification({
              type: "error",
              text: t("layout.load_template_error"),
            });
            generalStore.loadingTemplate = false;
            console.error(e);
          });
      })
      .catch((e) => {
        notificationsStore.createNotification({
          type: "error",
          text: e.body.err,
        });

        generalStore.loadingTemplate = false;
        console.error(e);
      });
  }

  function loadJson(json: string) {
    generalStore.loadingTemplate = true;
    mjmlStore
      .authorizePromise()
      .then(() => {
        mjmlStore.loadJson(json);

        if (!mjmlStore.mjml.style?.p) {
          mjmlStore.setStyle({
            tag: "p",
            attr: "font-size",
            value: "11px",
          });

          mjmlStore.setStyle({
            tag: "p",
            attr: "font-family",
            value: "Helvetica, Arial, sans-serif",
          });
        }

        mjmlStore.fixAnchorTagStyle();

        loaded.value = true;
        const message = {
          type: "callback",
          action: "onLoaded",
          data: {
            args: [],
          },
        };
        window.parent.postMessage(JSON.parse(JSON.stringify(message)), "*");
        generalStore.loadingTemplate = false;
      })
      .catch((e) => {
        console.error(e);
        if (e instanceof AuthorizationError) {
          notificationsStore.createNotification({
            type: "error",
            text: "Loading template failed due to an authorization issue.",
          });
        } else {
          notificationsStore.createNotification({
            type: "error",
            text: "Loading template failed",
          });
        }

        generalStore.loadingTemplate = false;
      });
  }

  return {
    loaded,
    loadTemplate,
    loadJson,
  };
};
